<template>
    <div class="wrapper main">
        <div class="header">
            <!-- Desktop -->
            <div class="container d-none d-sm-block">
                <div class="d-flex justify-content-between pt-4">
                    <div>
                        <div class="topNav">
                            <router-link :to="{ name: 'account'}">Min profil</router-link>
                            <a href="#">Brugervilkår</a>
                            <a href="#">Brug for hjælp?</a>
                        </div>
                    </div>
                    <div>
                        <p class="studentInfo"><span>Elev,</span> {{ student.name }}</p>
                        <a href="javascript:void(0);" class="btn signOut" @click="doLogout();">Afslut booking</a>
                    </div>
                </div>

                <h1 class="schoolName">{{ student.school.name }}</h1>
                
                <nav class="nav desktop">
                    <router-link :to="{ name: 'appointments' }">Køretimer</router-link>
                    <router-link :to="{ name: 'messages' }">Beskeder</router-link>
                </nav>
            </div>

            <!-- Mobile -->
            <div class="container d-block d-sm-none">
                <div class="d-flex justify-content-between">
                    <div>
                        <h1 class="schoolName">{{ student.school.name }}</h1>
                    </div>
                    <div class="d-flex align-items-center">
                        <a href="javascript:;" class="openMenu" v-on:click="showMenu = true">Menu</a>
                    </div>
                </div>
                <nav class="nav mobile" v-bind:class="{ open: showMenu }">
                    <div class="navBody">
                        <router-link :to="{ name: 'appointments' }">Køretimer</router-link>
                        <router-link :to="{ name: 'messages' }">Beskeder</router-link>
                        <router-link :to="{ name: 'account' }">Min profil</router-link>
                    </div>
                    <a href="javascript:;" class="closeMenu" v-on:click="showMenu = false">Luk menu</a>
                </nav>
            </div>

        </div>

        <!-- CONTENT TO MOVE -->
        <slot/>
        <!--  -->
    </div>
</template>

<style lang="sass">
@import '../../assets/scss/main.scss';
</style>


<script>
export default {
    name: 'LayoutMain',
    data: function() {
        return {
            student: this.$auth.user(),

            showMenu: false,
        }
    },

    methods: {
        doLogout() {
            this.$auth.logout({
                redirect: '/login',
            });
        }
    }
}
</script>

